import { ListItemIcon } from '@fiverr-private/list';

export default ListItemIcon;
